import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { media } from '../styles/Mixin';
import NormalText from "./NormalText";

const Container = styled.button`
  ${media.deskTop`width:100%;`}
  ${media.mobile`width:90%;`}
  border:0;
  border-radius: ${props => props.theme.borderRadius};
  color:white;
  font-weight: 600;
  background-color: ${props => props.backgroundColor === "blue" ? props.theme.blueColor : props.theme.redColor};
  text-align: center;
  padding: 7px 0px;
  cursor:pointer;
  ${media.deskTop`font-size:${props =>props.theme.deskFontSize};`}
  ${media.mobile`font-size: ${props => props.theme.mobileFontSize};`}
  &:focus{
        outline:none;
    }
`;

const Button = ({
    text,
    onClick,
    className,
    backgroundColor,
    type,
    loading,
    disabled,
}) =>
    <Container className={className} onClick={onClick} backgroundColor={backgroundColor} type={type} disabled={disabled}>
        {loading ? (<NormalText text={"loading..."}/>) : (<NormalText text={text}/>)}
    </Container>;

Button.propTypes = {
    text: PropTypes.string.isRequired
};

export default Button;